import { cn } from "@/lib/utils";
import CodeBlock from "./CodeBlock";

export interface ChatMessage {
  id: string;
  role: "user" | "assistant";
  content: string;
  timestamp: number;
}

interface ChatMessageProps {
  message: ChatMessage;
}

const ChatMessage = ({ message }: ChatMessageProps) => {
  const isCode = message.content.includes("```");

  const renderContent = () => {
    if (isCode) {
      const parts = message.content.split("```");
      return parts.map((part, index) => {
        if (index % 2 === 1) {
          // This is code block content
          const [language, ...code] = part.split("\n");
          return (
            <CodeBlock
              key={index}
              code={code.join("\n").trim()}
              language={language || "typescript"}
            />
          );
        }
        // This is regular text
        return <p key={index} className="whitespace-pre-wrap">{part}</p>;
      });
    }
    return <p className="whitespace-pre-wrap">{message.content}</p>;
  };

  return (
    <div
      className={cn(
        "flex w-full mb-4 animate-message-fade",
        message.role === "assistant" ? "justify-start" : "justify-end"
      )}
    >
      <div
        className={cn(
          "max-w-[80%] rounded-lg p-4",
          message.role === "assistant"
            ? "bg-deepseeker-gray text-deepseeker-text"
            : "bg-deepseeker-blue text-white"
        )}
      >
        {renderContent()}
      </div>
    </div>
  );
};

export default ChatMessage;